import { Trans } from '@lingui/react';
import { Box } from '@startuptools/ui/Box';
import { Button } from '@startuptools/ui/Button';
import { Card } from '@startuptools/ui/Card';
import { CardContent } from '@startuptools/ui/CardContent';
import { Typography } from '@startuptools/ui/Typography';

export const EmptyState = ({ onCreateClick }: { onCreateClick: () => void }) => {
  return (
    <Card
      size="lg"
      variant="plain"
      orientation="horizontal"
      sx={{
        textAlign: 'center',
        maxWidth: '100%',
        width: 500,
        overflow: 'auto',
      }}
    >
      <CardContent sx={{ gap: 1.5, minWidth: 200, m: 2 }}>
        <Typography level="title-lg">
          <Trans id="What is a CapTable?" />
        </Typography>
        <Typography fontSize="sm" sx={{ mt: 0.5 }}>
          <Trans id="Creating CapTables allows you to keep track of different future scenarios of the ownership of your company. Sync the current share register, include dilution from option program and create fictional rounds to see the effect on the ownership of all shareholders." />
        </Typography>
        <Box>
          <Button onClick={onCreateClick} size="lg">
            <Trans id="Get started" />
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};
